// extracted by mini-css-extract-plugin
export default {"container":"ToggleSwitch_container__pjAMF"};